import { render, staticRenderFns } from "./UserManagementList.template.vue?vue&type=template&id=f5afeb60&scoped=true&"
var script = {}
import style0 from "./UserManagementList.template.vue?vue&type=style&index=0&id=f5afeb60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5afeb60",
  null
  
)

export default component.exports